<template>

    <div v-if="isLoading" v-loading="isLoading"  class="overlay" >
        <!-- <w-spinner></w-spinner> -->
    
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters("loading", ["isLoading"])
    },
};
</script>

<style>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(168, 168, 168, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>